import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/tHdWwGui1BVhGPnZQ6y9k5/WhatsApp_Image_2026-07-30_at_4.14.54_PM.jpg';

/* The source artwork is centered on a white canvas, so the mark is cropped to its content box. */
const CROP = {
  left: 0.2072,
  top: 0.2917,
  width: 0.5903,
  height: 0.3596
};
const SOURCE_RATIO = 737 / 1279;
type LogoMarkProps = {
  width?: number;
  className?: string;
};
export function LogoMark({
  width = 118,
  className = ''
}: LogoMarkProps) {
  const imageWidth = width / CROP.width;
  const imageHeight = imageWidth * SOURCE_RATIO;
  const boxHeight = imageHeight * CROP.height;
  return <span className={`relative block overflow-hidden ${className}`} style={{
    width,
    height: boxHeight
  }} data-id="element-22" data-mp="ht8bxtr52f3y">
      <img src={LOGO_URL} alt="Standard Consulting Advice" className="absolute max-w-none" style={{
      width: imageWidth,
      height: imageHeight,
      left: -imageWidth * CROP.left,
      top: -imageHeight * CROP.top
    }} data-id="element-23" data-mp="2yhc6i0czakcf" />
    </span>;
}
type LogoProps = {
  variant?: 'dark' | 'light';
};
export function Logo({
  variant = 'dark'
}: LogoProps) {
  const {
    t
  } = useLanguage();
  return <a href="#top" aria-label={t.nav.homeLabel} className={`inline-flex items-center rounded-2xl transition-all duration-300 hover:-translate-y-0.5 ${variant === 'light' ? 'bg-white px-4 py-2.5 shadow-soft' : ''}`} data-id="element-24" data-mp="1nwr40ozbjllr">
      <LogoMark width={132} data-id="element-25" data-mp="1xsayr825ce8x" />
    </a>;
}